export const base_path = ".";
export const img_path = "./";
//export const API_BASE_PATH = "https://mis-test.iatsolutions.co:9999";
//export const API_BASE_PATH = "https://mis-test.iatsolutions.co:9998";
//export const API_BASE_PATH = "https://mis-test.iatsolutions.co:9997";
export const API_BASE_PATH = "https://api.mis.royaltechsystems.co.in";
//export const API_BASE_PATH = "https://api.mis-testenv.iatsolutions.co";